var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1662_17170",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H17.8027L24.5 58L31.1973 48H38C43.5228 48 48 43.5229 48 38V10C48 4.47715 43.5229 0 38 0H10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H17.8027L24.5 58L31.1973 48H38C43.5228 48 48 43.5229 48 38V10C48 4.47715 43.5229 0 38 0H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8027 48L18.6336 47.4435L18.3366 47H17.8027V48ZM24.5 58L23.6691 58.5565L24.5 59.7971L25.3309 58.5565L24.5 58ZM31.1973 48V47H30.6634L30.3664 47.4435L31.1973 48ZM1 10C1 5.02944 5.02944 1 10 1V-1C3.92487 -1 -1 3.92487 -1 10H1ZM1 38V10H-1V38H1ZM10 47C5.02944 47 1 42.9706 1 38H-1C-1 44.0751 3.92487 49 10 49V47ZM17.8027 47H10V49H17.8027V47ZM25.3309 57.4435L18.6336 47.4435L16.9719 48.5565L23.6691 58.5565L25.3309 57.4435ZM30.3664 47.4435L23.6691 57.4435L25.3309 58.5565L32.0281 48.5565L30.3664 47.4435ZM38 47H31.1973V49H38V47ZM47 38C47 42.9706 42.9706 47 38 47V49C44.0751 49 49 44.0751 49 38H47ZM47 10V38H49V10H47ZM38 1C42.9706 1 47 5.02944 47 10H49C49 3.92487 44.0751 -1 38 -1V1ZM10 1H38V-1H10V1Z",
    fill: "#003E6B",
    mask: "url(#path-1-inside-1_1662_17170)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleButton);
export default __webpack_public_path__ + "static/media/SingleButton.f65d42698640aea9c63077afa0250151.svg";
export { ForwardRef as ReactComponent };